<div class="form-row">
    <div class="form-group mb-20">
        <label class="control-label col-xs-6">
            {{ "control_hide_widget" | translate }}
        </label>
        <div class="col-xs-6">
            <div class="btn-group btn-group-justified btn-group-with-tooltip" data-toggle="buttons">
                <button
                    class="btn btn-grey"
                    [class.active]="hideOnDesktop"
                    [tooltip]="onDesktopTooltip"
                    (click)="onHideOnDesktopChange(!hideOnDesktop)"
                >
                    <ng-template #onDesktopTooltip>
                        {{ "control_hide_on_desktop_tooltip" | translate }}
                    </ng-template>
                    <img src="./assets/img/websites/lpc-desktop-icon.svg" alt="Hide on desktop" />
                </button>
                <button
                    class="btn btn-grey"
                    [class.active]="hideOnTablet"
                    [tooltip]="onTabletTooltip"
                    (click)="onHideOnTabletChange(!hideOnTablet)"
                >
                    <ng-template #onTabletTooltip>
                        {{ "control_hide_on_tablet_tooltip" | translate }}
                    </ng-template>
                    <img src="./assets/img/websites/lpc-tablet-icon.svg" alt="Hide on tablet" />
                </button>
                <button
                    class="btn btn-grey"
                    [class.active]="hideOnMobile"
                    [tooltip]="onMobileTooltip"
                    (click)="onHideOnMobileChange(!hideOnMobile)"
                >
                    <ng-template #onMobileTooltip>
                        {{ "control_hide_on_mobile_tooltip" | translate }}
                    </ng-template>
                    <img src="./assets/img/websites/lpc-mobile-icon.svg" alt="Hide on mobile" />
                </button>
            </div>
        </div>
    </div>
</div>
